import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import {
  Card,
  Typography,
  FormControlLabel,
  Checkbox,
  TextField,
  Divider,
  FormControl,
  Select,
  MenuItem,
  InputLabel,
} from '@material-ui/core';
import { useStyles } from './Interfaces.style';
import DicomInterfaces from './Dicom/DicomInterfaces';
import WorklistInterfaces from './Worklist/WorklistInterfaces';
import RisInterfaces from './Ris/RisInterfaces';
import SelectWithOther from './Common/SelectWithOther';

const Interfaces = ({
  priors_fetching,
  query_worklist,
  settings,
  report,
  updateSettingsCheckbox,
  updateSettingsValue,
  setReportRulesChanged,
  updateReportField,
  updateReportFieldValue,
  updateReportFieldCheckbox,
}) => {
  const classes = useStyles();
  const { t } = useTranslation();

  const languageOptions = [
    { value: 'en', label: 'English' },
    { value: 'fr', label: 'Français' },
    { value: 'de', label: 'Deutsch' },
    { value: 'es', label: 'Español' },
    { value: 'lt', label: 'Lithuanian' },
    { value: 'pl', label: 'Polski' },
    { value: 'it', label: 'Italiano' },
  ];
  const handleCheckboxChange = useCallback(
    (event) => updateSettingsCheckbox(event),
    [updateSettingsCheckbox],
  );

  return (
    <>
      {/* Reports section */}
      <Card elevation={1} className={classes.card_split_container}>
        <div className={classes.reports_section_container}>
          <div className={classes.header_container}>
            <Typography
              variant='h6'
              color='primary'
              className={`${classes.titleSettingsCard} ${classes.title_margin}`}>
              {t('Settings.send_reports')}
            </Typography>
          </div>
          <div className={classes.report_settings_container}>
            {/* hide operator name */}
            <div className={classes.report_options_container}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={!!report.hide_operator_name}
                    onChange={updateReportFieldCheckbox}
                    name='hide_operator_name'
                  />
                }
                label={t('Settings.hide_operator_name')}
              />
            </div>

            {/* image compression */}
            <div className={classes.report_options_container}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={!!report.image_compression}
                    onChange={updateReportFieldCheckbox}
                    name='image_compression'
                  />
                }
                label={t('Settings.compress_image_report')}
              />
            </div>

            {/* priors report */}
            <div className={classes.report_options_container}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={!!settings.priors_report}
                    onChange={handleCheckboxChange}
                    name='priors_report'
                  />
                }
                label={t('Settings.priors_report')}
              />
            </div>

            {/* report delay */}
            <div className={classes.report_options_container}>
              <TextField
                label={t('Settings.delay')}
                fullWidth={false}
                value={report.sending_delay}
                onChange={updateReportFieldValue}
                name='sending_delay'
                className={`${classes.report_settings_input} ${classes.report_delay_input}`}
                size='small'
                variant='outlined'
                autoComplete='off'
              />
            </div>

            {/* Set language */}
            <div className={classes.report_options_container}>
              <FormControl fullWidth>
                <InputLabel id='language-label'>{t('Settings.report_language')}</InputLabel>
                <Select
                  labelId='language-label'
                  name='language'
                  value={report.language}
                  onChange={(e) => updateReportField(e.target.name, e.target.value)}>
                  {languageOptions.map((option, i) => (
                    <MenuItem className={classes.radio_label_option} value={option.value} key={i}>
                      {option.label}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </div>
          </div>
        </div>
      </Card>
      {/* Priors section */}
      {(priors_fetching || query_worklist) && (
        <Card elevation={1} className={classes.card_split_container}>
          <div className={classes.priors_section_container}>
            <div className={classes.header_container}>
              <Typography
                variant='h6'
                color='primary'
                className={`${classes.titleSettingsCard} ${classes.title_margin}`}>
                {t('Settings.priors_settings')}
              </Typography>
            </div>
            {/* Prior limit */}
            <div className={classes.priors_limits_container}>
              {/* Year limit */}
              <div className={classes.priors_limits_container_item}>
                <SelectWithOther
                  label_explanation={t('Settings.prior_year_limit_explanation')}
                  label={t('Settings.prior_year_limit')}
                  value={settings.priors_years_limit}
                  min={1}
                  max={5}
                  onChange={(val) =>
                    updateSettingsValue({
                      target: { name: 'priors_years_limit', value: val },
                    })
                  }
                />
              </div>
              <Divider orientation='vertical' flexItem />
              {/* Number of studies limit */}
              <div className={classes.priors_limits_container_item}>
                <SelectWithOther
                  label_explanation={t('Settings.prior_limit_explanation')}
                  label={t('Settings.prior_limit')}
                  value={settings.priors_number_limit}
                  min={1}
                  max={5}
                  onChange={(val) =>
                    updateSettingsValue({
                      target: { name: 'priors_number_limit', value: val },
                    })
                  }
                />
              </div>
            </div>
          </div>
        </Card>
      )}
      {/* Interfaces section */}
      <DicomInterfaces setReportRulesChanged={setReportRulesChanged} />
      {query_worklist && <WorklistInterfaces setReportRulesChanged={setReportRulesChanged} />}{' '}
      <RisInterfaces setReportRulesChanged={setReportRulesChanged} />
    </>
  );
};

export default Interfaces;
